import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdminSettingsService } from '../../../_services/admin/admin-settings.service';
import { LayoutKind } from '../../../_models/common/layout.kind';
import { SettingsBase } from '../../../_models/admin/settings/settings.base';

@Component({
  selector: 'app-admin-settings-layout',
  templateUrl: './admin-settings-layout.component.html',
  styleUrls: ['./admin-settings-layout.component.scss']
})
export class AdminSettingsLayoutComponent implements OnInit {
  layoutKind = LayoutKind;
  settings: SettingsBase;

  constructor(
    public adminSettingsService: AdminSettingsService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.data
      .subscribe((data: any) => {
        this.settings = data.settings;
      });
  }
}
